import { ax } from 'src/client'
import * as serviceURLS from './serviceURLS'

const urlWithID = (url, id) => {
  return url.replace(':id', id)
}

export function getCompany(companyIdentifier) {
  // companyIdentifier can be both a CRN or a company-svc id
  return ax.get(urlWithID(serviceURLS.GET_COMPANY, companyIdentifier))
}

export function updateCompany(companyIdentifier, payload) {
  return ax.put(urlWithID(serviceURLS.EDIT_COMPANY, companyIdentifier), payload)
}

export function getTimelineComments(companyID) {
  return ax.get(urlWithID(serviceURLS.GET_COMMENTS, companyID))
}

export function getCompanyProducts(companyID) {
  return ax.get(urlWithID(serviceURLS.GET_COMPANY_PRODUCTS, companyID))
}

export function updateCompanyProducts(companyID, productID, payload) {
  return ax.patch(
    urlWithID(serviceURLS.UPDATE_COMPANY_PRODUCTS, companyID).replace(
      ':product_id',
      productID
    ),
    payload
  )
}

export function createCompanyBankAccount(companyID, payload) {
  return ax.post(urlWithID(serviceURLS.CREATE_BANK_ACCOUNT, companyID), payload)
}

export function updateBankAccount(companyID, bankAccountID, payload) {
  return ax.patch(
    urlWithID(serviceURLS.UPDATE_BANK_ACCOUNT, companyID).replace(
      ':bank_account_id',
      bankAccountID
    ),
    payload
  )
}

export function getCompanyBankAccounts(companyID) {
  return ax.get(urlWithID(serviceURLS.BANK_ACCOUNTS, companyID))
}

export function suspend(companyID, payload) {
  return ax.put(urlWithID(serviceURLS.SUSPEND_COMPANY, companyID), payload)
}

export function unsuspend(companyID) {
  return ax.put(urlWithID(serviceURLS.UNSUSPEND_COMPANY, companyID))
}

export function changeGrade(companyId, payload) {
  return ax.post(urlWithID(serviceURLS.CHANGE_GRADE, companyId), payload, {
    headers: { 'content-type': 'multipart/form-data' }
  })
}

export function overrideEtpFinancingIndicator(companyId, { value }) {
  return ax.put(
    urlWithID(serviceURLS.OVERRIDE_ETP_FINANCING_INDICATOR, companyId),
    { value }
  )
}

export function getCompanyChecks(companyId) {
  return ax.get(urlWithID(serviceURLS.GET_COMPANY_CHECKS, companyId))
}

export function runCompanyChecks(companyId) {
  return ax.post(urlWithID(serviceURLS.POST_COMPANY_CHECKS, companyId))
}
